// extracted by mini-css-extract-plugin
export default {"container":"hW-z","topReviewHeading":"iW-z","criticalReview":"jW-z","favorableReview":"kW-z","vsSeparator":"lW-z"};